<template> </template>

<script>
import * as StoreUtil from "../../util/StoreUtil";
import API from "../../api/API";
export default {
  name: "PutCursor",
  data() {
    return {
      timer: null
    };
  },
  computed: {
    isDraw() {
      return StoreUtil.isModeTutorial() || StoreUtil.isModeDraw() || StoreUtil.isModePublish();
    }
  },
  watch: {
    isDraw(value) {
      console.log("draw", value);
      if (value) this.start();
      else this.end();
    }
  },
  methods: {
    start() {
      // EnterFrameI.on("update", this.update);
      this.timer = setTimeout(() => {
        this.update();
      }, this.$store.state.config.putCursorInterval);
    },
    end() {
      // EnterFrameI.off("update", this.update);
      clearTimeout(this.timer);
    },
    update() {
      this.callAPI();
      this.start();
    },
    callAPI() {
      const tool = this.$store.state.tool;
      const pos = this.$store.state.area.pos;
      const data = {
        type: tool.tool,
        color: tool.color + 1,
        x: pos.x,
        y: pos.y
      };
      API.putCursor(data);
    }
  }
};
</script>

<style scoped></style>
